import script from "./PaginationCompontens.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaginationCompontens.vue?vue&type=script&setup=true&lang=ts"

import "./PaginationCompontens.vue?vue&type=style&index=0&id=979a6a12&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-979a6a12"]])

export default __exports__